export enum SocialButtonsPlacement {
  FIRST,
  LAST,
}

export enum SocialButtonStyle {
  STACK,
  ROW,
  ICONS,
}

export const LAYOUT_DEFAULTS = {
  socialButtonsFirst: SocialButtonsPlacement.LAST,
  socialButtonsStyle: SocialButtonStyle.STACK,
  fullSubmitButtonWidth: true,
} as const;

const SIDES_PADDING_DEFAULTS = {
  classic: {
    mobile: 16,
    desktop: 155,
  },
  // Builder-popup editors (Editor 3 + Studio 2) share these paddings.
  builderPopup: {
    mobile: 12,
    desktop: 24,
  },
} as const;

export const getSidesPaddingDefault = ({
  isEditor3 = false,
  isStudio2 = false,
  isMobile,
}: {
  isEditor3?: boolean;
  isStudio2?: boolean;
  isMobile?: boolean;
}) => {
  const defaults =
    isEditor3 || isStudio2
      ? SIDES_PADDING_DEFAULTS.builderPopup
      : SIDES_PADDING_DEFAULTS.classic;

  return isMobile ? defaults.mobile : defaults.desktop;
};

export const resolveSidesPadding = ({
  isEditor3,
  isMobile,
  value,
}: {
  isEditor3: boolean;
  isMobile: boolean;
  value: number;
}) => {
  const classicDefault = getSidesPaddingDefault({ isMobile });

  // On live sites, style-param defaults cannot detect Editor3 from app data.
  // If the stored value is still Classic's default, treat it as untouched and
  // resolve it to the Editor3 default; otherwise keep the customized value.
  return isEditor3 && value === classicDefault
    ? getSidesPaddingDefault({ isEditor3: true, isMobile })
    : value;
};
